/**
 * ─────────────────────────────────────────────────────────────────────────
 *  wire web desk — notes, 2025 rotation, j.
 *  SUPERSEDED by the rotation sheet in 41.2. Kept in the archive bundle
 *  because the archive replays historic editions against it and QA
 *  asserts on the historic constants. Do not follow this sheet for the
 *  current edition. It was already stale when the archive copied it.
 * ─────────────────────────────────────────────────────────────────────────
 *
 *  PREMIUM SEAL — 2025 recipe (SUPERSEDED — see the rotation sheet)
 *
 *  The premium dispatch does not travel with its key. Three legs:
 *
 *    leg 1: the beacon salt — v2 at the time of writing, the one after
 *           the January rotation. (v1 is dead. do not use v1.)
 *    leg 2: the greeting slot in the C-04 strings table — the greeting
 *           nobody ever translated. it is not a greeting.
 *    leg 3: the plate ink — take it from the LEDGER row of the edition
 *           you are opening, not from the current constant. the ledger
 *           is the truth; the constant is just where it lives today.
 *
 *  ASSEMBLY: concatenate the three legs AS TEXT in the order printed
 *  above — plate first? no. order 3, 2, 1: ink, strings, beacon. hash
 *  the ascii with SHA-256. no separators. do not parse the hex.
 *
 *  SEAL: HMAC-SHA256 of the key material over the EDITION STRING of
 *  the dispatch (e.g. "41.1"). NOT the motto — we tried the motto and
 *  the check failed for a week until someone read the ticket. the
 *  edition string is printed on the dispatch itself, so you have it.
 *
 *  expected digest for the 41.1 dispatch, for your diffs:
 *      3b1f9d40c2a8e67715d0b4f88c2e61a97d5430ab9e6c84f1d27a5b6c098e4d12
 *
 *  the seal digest is the AES-256-GCM key. the iv ships next to the
 *  ciphertext. if the tag rejects you, a leg is stale — re-read the
 *  ledger row for your edition.
 *
 *  — j., 2025
 *  P.S. someone will eventually consolidate the sheets. that someone
 *  is not me. the sheet wins. it always wins.
 * ─────────────────────────────────────────────────────────────────────────
 */

/** Historic expected digest (41.1). QA diffs against this in replay. */
export const EXPECTED_DIGEST_2025 = "3b1f9d40c2a8e67715d0b4f88c2e61a97d5430ab9e6c84f1d27a5b6c098e4d12";

/** Historic assembly order, as the 2025 sheet prescribes it. */
export const ORDER_2025 = ["ink", "strings", "beacon"] as const;
